import { lazy } from "react";
import { Outlet } from "react-router-dom";
// CUSTOM COMPONENTS
import Loadable from "./Loadable";
import { AuthGuard } from "components/auth";
import DashboardLayout from "layouts/dashboard/DashboardLayout";
// CUSTOM PAGES
const DashboardHome = Loadable(lazy(() => import("pages/dashboard")));

// USER LIST PAGES
const UserListView = Loadable(lazy(() => import("pages/dashboard/users/list")));

// USER ACCOUNT PAGE
const Account = Loadable(lazy(() => import("pages/dashboard/accounts")));

// PURCHASE LIST PAGE
const PurchaseList = Loadable(lazy(() => import("pages/dashboard/purchase/list")));

// PURCHASED IDEAS LIST PAGE
const PurchasedIdeasList = Loadable(lazy(() => import("pages/dashboard/purchased-ideas/list")));

// DEPOSIT PAGE
const DepositList = Loadable(lazy(() => import("pages/dashboard/deposit/list")));

// WITHDRAW PAGE
const WithdrawList = Loadable(lazy(() => import("pages/dashboard/withdraw/list")));

// ALL ARTICLE CATEGORY RELATED PAGES
const ArticleCategoryList = Loadable(lazy(() => import("pages/dashboard/articlecategory/list")));

// ARTICLE PAGE
const ArticleList = Loadable(lazy(() => import("pages/dashboard/article/list")));
const ArticleGrid = Loadable(lazy(() => import("pages/dashboard/article/grid")));
const ArticleCreate = Loadable(lazy(() => import("pages/dashboard/article/create")));
const ArticleDetails = Loadable(lazy(() => import("pages/dashboard/article/details")));

// MATERIAL CATEGORY PAGE
const MaterialCategoryList = Loadable(lazy(() => import("pages/dashboard/materialcategory/list")));
const MaterialCategoryCreate = Loadable(lazy(() => import("pages/dashboard/materialcategory/create")));

// MATERIAL LIST PAGE
const MaterialList = Loadable(lazy(() => import("pages/dashboard/material/list")));
const MaterialCreate = Loadable(lazy(() => import("pages/dashboard/material/create")));

// ADMIN LIST PAGE
const AdminList = Loadable(lazy(() => import("pages/dashboard/admin/list")));
const AdminCreate = Loadable(lazy(() => import("pages/dashboard/admin/create")));

// ALL SUBSCRIPTION RELATED PAGES
const SubscriptionList = Loadable(lazy(() => import("pages/dashboard/subscription/list")));

// SMS PARSER PAGES
const SmsParserList = Loadable(lazy(() => import("pages/dashboard/sms-parser/list")));

// ALL REPORT RELATED PAGES
const ReportList = Loadable(lazy(() => import("pages/dashboard/report/list")));

// ALL SETTINGS RELATED PAGES
const Settings = Loadable(lazy(() => import("pages/dashboard/settings")));

// CHAT PAGE
const Chat = Loadable(lazy(() => import("pages/dashboard/chat")));

// CALCULATIONS PAGE
const CalculationsList = Loadable(lazy(() => import("pages/dashboard/calculations/list")));

export const DashboardRoutes = [{
  path: "dashboard",
  element: <AuthGuard>
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  </AuthGuard>,
  children: [{
    index: true,
    element: <DashboardHome />
  }, {
    path: "user-list",
    element: <UserListView />
  }, {
    path: "account",
    element: <Account />
  }, {
    path: "deposit-list",
    element: <DepositList />
  }, {
    path: "purchase-list",
    element: <PurchaseList />
  }, {
    path: "purchased-ideas-list",
    element: <PurchasedIdeasList />
  }, {
    path: "withdraw-list",
    element: <WithdrawList />
  }, {
    path: "articlecategory-list",
    element: <ArticleCategoryList />
  }, {
    path: "article-list",
    element: <ArticleList />
  }, {
    path: "article-grid",
    element: <ArticleGrid />
  }, {
    path: "create-article",
    element: <ArticleCreate />
  }, {
    path: "article-details",
    element: <ArticleDetails />
  }, {
    path: "materialcategory-list",
    element: <MaterialCategoryList />
  }, {
    path: "create-materialcategory",
    element: <MaterialCategoryCreate />
  }, {
    path: "material-list",
    element: <MaterialList />
  }, {
    path: "create-material",
    element: <MaterialCreate />
  }, {
    path: "admin-list",
    element: <AdminList />
  }, {
    path: "create-admin",
    element: <AdminCreate />
  }, {
    path: "edit-admin/:id",
    element: <AdminCreate />
  }, {
    path: "subscription-list",
    element: <SubscriptionList />
  }, {
    path: "sms-parser-list",
    element: <SmsParserList />
  }, {
    path: "report-list",
    element: <ReportList />
  }, {
    path: "settings",
    element: <Settings />
  }, {
    path: "chat",
    element: <Chat />
  }, {
    path: "calculations-list",
    element: <CalculationsList />
  }]
}];